import React from "react";
import "./error-view.scss";

interface IErrorView
{
    errors?: string;
}

export const ErrorView = ({ errors }: IErrorView) =>
{
    return (
        <div className="error-message">{ errors }</div>
    );
};